var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view",class:{ 'map-detail': _vm.isShowMapDetail }},[_c('div',{staticClass:"map-container",attrs:{"id":"container"}}),(_vm.isShowMapDetail)?_c('div',{staticClass:"active-cinema"},[_vm._v(" 456 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }